interface IHighlightText {
  text: string;
  query: string;
  mark?: boolean;
}

function escapeRegExp(string: string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export const HighlightText = ({ text, query, mark = false }: IHighlightText) => {
  const safeQuery = escapeRegExp(query);
  const parts = text.split(new RegExp(`(${safeQuery})`, 'gi'));

  return (
    <>
      {parts.map((part, i) =>
        part.toLowerCase() === query.toLowerCase() ? (
          <strong key={i}>{mark ? <mark>{part}</mark> : part}</strong>
        ) : (
          part
        ),
      )}
    </>
  );
};
